<template>
<div>
  <div>
    <div class="tasks-title-box w-100 rounded">
      <v-row class="ma-5">
        <v-col class="my-auto mx-auto mobile-d-none"><h3>پشتیبانی</h3></v-col>
        <v-col class="text-left" xs="12">
          <v-text-field label="جست و جو کنید"
                        placeholder="حداقل ۳ حرف "
                        dense outlined dir="ltr"
                        v-model="search_field"
                        class="search-tasks"
                        clearable
                        @click:clear="search_field=null;get_tickets()"
                        @keydown.enter="get_tickets()"
                        :rules="[rules.min_3]"
                        style="margin-bottom: -25px"
          >
            <template v-slot:append v-if="search_field && search_field.length>=3">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red" v-bind="attrs" v-on="on" @click="get_tickets()"> mdi-magnify </v-icon>
                </template>
                <span>
                    برای جست و جو کلیک کنید.
                  </span>
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>
        <v-col class="text-left" xs="12">
          <v-btn class="elevation-0" large @click="create_ticket_dialog=true;">
            <v-icon small >mdi-plus</v-icon>
            <div class="mobile-d-none">ثبت تیکت جدید</div>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
  <div class="last-changes rounded-lg container">
    <h2 class="text-center mb-3">تیکت های ثبت شده</h2>
      <v-data-table
            dense
            :loading="loading_tickets"
            hide-default-footer
            :headers="tickets_table.headers"
            :items="tickets_table.desserts"
            no-data-text="بردی پیدا نشد!"
            loading-text="در حال دریافت اطلاعات ..."
            class="elevation-0"
        >
          <template v-slot:item.created_at="{ item }">
            <v-tooltip top color="red">
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs"
                   v-on="on">
                  {{new Date(item.created_at.split('T')[0]).toLocaleDateString('fa-IR')}}
                </a>
              </template>
              <span>{{ convert_en_to_fa_number(item.created_at.split('T')[1].split('.')[0]) }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip
                class="lighten-5 my-4"
                :color="`${item.status==='W'?'blue':item.status==='P'?'orange':'green'}`"
                :style="`color: ${item.status==='W'?'blue':item.status==='P'?'orange':'green'}`"
                v-text="item.status==='W'?'در صف انتظار':item.status==='P'?'در حال انجام':'  انجام شده  '"
            ></v-chip>
          </template>

          <template v-slot:item.description="{ item }">
            <v-tooltip v-if="item.description.length>80" top color="gray" max-width="50em">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs"
                   v-on="on">
                  {{item.description.slice(0,30)+'...'}}
                </div>
              </template>
              <div class="my-auto">{{item.description}}</div>
            </v-tooltip>
            <div v-else>
              {{item.description}}
            </div>
          </template>
        </v-data-table>
        <v-pagination
            v-if="ticket_count > 10"
            v-model="page"
            color="#D20003"
            rounded
            @input="get_tickets()"
            :length="ticket_count%10!==0?parseInt(ticket_count/10)+1:parseInt(ticket_count/10)"
            :total-visible="7"
        ></v-pagination>
  </div>

  <v-dialog v-model="create_ticket_dialog" height="10vh" width="30em">
    <v-card>
      <v-card-title>افزودن تیکت</v-card-title>
      <v-card-text>
        <v-container>
          <v-text-field v-model="ticket_form.title" rounded outlined label="عنوان"></v-text-field>
          <v-textarea v-model="ticket_form.description" rounded outlined label="توضیحات"></v-textarea>
          <v-btn color="success" @click="send_new_tickets()" :disabled="!(ticket_form.title && ticket_form.description)" :loading="create_btn">ثبت تیکت</v-btn>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "HomeSupports",
  data:()=>({
    key: localStorage.getItem('key'),
    create_ticket_dialog:false,
    loading_tickets: false,
    ticket_form:{created_by:1},
    search_field:null,
    ticket_count:0,
    page:1,
    tickets_table: {
      headers: [
        {text: 'شماره',align: 'center', value: 'id'},
        {text: 'عنوان',align: 'center', value: 'title'},
        {text: 'شرح',align: 'center', value: 'description'},
        {text: 'زمان ثبت',align: 'center', value: 'created_at'},
        {text: 'ثبت شده توسط',align: 'center', value: 'created_by.get_full_name'},
        {text: 'وضعیت',align: 'center', value: 'status'},
      ],
      desserts:[],
    },
    create_btn:false,
    rules: {
      min_3: v => v.length >= 3 || 'حداقل ۳ حرف',
    },
  }),
  created() {
    if (Vue.prototype.$GLOBAL_DATA.user['degree'] != 4){
      this.tickets_table.headers.splice(4,1)
    }
    this.get_tickets();
  },
  methods:{
    async get_tickets(){
      this.loading_tickets = true;

      try {
        const response = await axios.
        get(`${this.BACKEND_LINK}/api/ticket/?page=${this.page}${this.search_field?`&search=${this.search_field}`:''}`,{
          headers: {'Authorization': `Token ${this.key}`}
        });
        if (response.data){
          this.ticket_count = response.data.count;
          this.tickets_table.desserts = response.data.results;
        }
      } catch (error) {
        this.$snotify.error(`در دریافت اطلاعات مشکلی به وجود آمد. کد : ${error.response.status}`, 'خطا');
      } finally {
        this.loading_tickets = false;
      }
    },

    send_new_tickets(){
      this.create_btn = true;
      axios.post(`${this.BACKEND_LINK}/api/ticket/`,this.ticket_form,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        if(response.status === 201) {
          this.$snotify.success('تیکت جدید با موفقیت ثبت شد.', 'ثبت تیکت');
          this.get_tickets();
          this.ticket_form = {};
          this.create_ticket_dialog = false;
        }
        else {
            this.$snotify.error(`در ثبت تیکت مشکلی به وجود آمد. کد : ${response.status}`, 'ثبت تیکت');
        }
        this.create_btn = false;
      }).catch((error)=>{
        this.$snotify.error(`در ثبت تیکت مشکلی به وجود آمد. کد : ${error.response.status}`, 'ثبت تیکت');
        this.create_btn = false;
      })
    },
    change_search_field(){
      this.search_items=this.tickets_table.desserts;
    },
  }
}
</script>
